import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/datetime";
import { Card } from "@/components/email/EmParts";

const STEPS = [["sent", "Sent"], ["delivered", "Delivered"], ["open", "Opened"], ["click", "Clicked"]];

const stepTime = (s, k) => (k === "sent" ? s.sent_at : (s.events.find((e) => e.event === k) || {}).ts);

export const TestActivityCard = ({ campaignId }) => {
  const [sends, setSends] = useState(null);
  useEffect(() => { api.get(`/email-marketing/campaigns/${campaignId}/test-activity`).then((r) => setSends(r.data.sends)).catch(() => setSends([])); }, [campaignId]);
  if (!sends) return null;
  return (
    <Card title="Test activity (not counted in campaign stats)" testId="em-test-activity">
      {!sends.length && <p className="text-sm text-slate-400">No test sends yet.</p>}
      <div className="space-y-3">{sends.map((s) => (
        <div key={s.id} className="text-xs border-t border-slate-100 pt-2" data-testid={`em-test-send-${s.id}`}>
          <p className="font-semibold text-slate-700">{s.email} · <span className="capitalize">{s.status}</span>{s.error ? ` · ${s.error}` : ""}</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-1 mt-1">{STEPS.map(([k, l]) => {
            const t = stepTime(s, k);
            return <span key={k} className={t ? "text-emerald-700" : "text-slate-400"} data-testid={`em-test-step-${k}-${s.id}`}>{l}: {t ? formatDateTime(t) : "not received"}</span>;
          })}</div>
          {s.events.filter((e) => e.event === "click").map((e, i) => <p key={i} className="text-slate-500 truncate">Click → {e.url}</p>)}
        </div>))}</div>
    </Card>
  );
};
